import {createRouter, createWebHashHistory} from 'vue-router'

const routes = [
    {
        path: '/reg',
        name: 'reg',
        component: () => import( '@/views/RegView.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import( '@/views/LoginView.vue')
    },
    {
        path: '/',
        name: 'home',
        component: () => import( '@/views/ListView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/items/:id',
        name: 'item',
        component: () => import( '@/views/ItemView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import( '@/views/ProfileView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: () => import( '@/views/CalendarView.vue'),
        meta: { requiresAuth: true }
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            // Возвращает позицию, если она есть (при переходе "Назад/Вперед")
            return savedPosition;
        } else {
            // Иначе прокручивает страницу наверх
            return { top: 0 };
        }
    },
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = localStorage.getItem('token');
    if (to.meta.requiresAuth && !isAuthenticated) {
        next('/login');
    } else {
        next();
    }
});

export default router
